const enums = {}

enums.requestStatus = {
  DRAFT: 'draft',
  SUBMITTED: 'submitted',
  CANCELLED: 'cancelled',
  VALUED: 'valued',
  AWAITING_ONSITE: 'awaiting-onsite',
  OUT_OF_SCOPE: 'out-of-scope',
  FAILED: 'failed',
}

enums.roles = [
  '-:admin',
  '-:developer',
  '-:hotliner',
  '-:support',
  '-:prefiller',
  'cat:submitter',
  'cat:explorer',
  'cat:reporter',
  'cat:dispatcher',
  'cat:borrower',
  'ers:submitter',
  'ers:substitute',
  'ers:reporter',
  'ers:dispatcher',
  'dvm:referrer',
  'dvm:submitter',
  'dvm:substitute',
  'dvm:valuer',
  'dvm:borrower',
  'dvm:dispatcher',
  'dvm:reporter',
  'ovm:referrer',
  'ovm:submitter',
  'ovm:substitute',
  'ovm:valuer',
  'ovm:borrower',
  'ovm:dispatcher',
  'ovm:reporter',
  'avm:submitter',
  'ers:referrer',
  'ers:borrower',
  'ers:reporter',
  'oepc:referrer',
  'oepc:submitter',
  'oepc:borrower',
  'oepc:valuer',
  'oepc:dispatcher',
  'oepc:reporter',
  'asset:creator',
  'asset:borrower',
]

enums.userType = {
  VALUER: 'valuer',
  DISPATCHER: 'dispatcher',
  BORROWER: 'borrower',
  SUBMITTER: 'submitter',
  CREATOR: 'creator',
}

enums.supportRolePermissions = {
  CAN_COMPLETE_FLOW: {
    moduleRoles: [{ role: 'dispatcher', modules: ['dvm', 'ovm', 'oepc'] }],
    globalRoles: ['hotliner', 'support'],
  },
}

enums.valuationTypes = {
  DVM: 'dvm',
  OVM: 'ovm',
  ERS: 'ers',
  OEPC: 'oepc',
  CAT: 'cat',
  ASSET: 'asset',
}

enums.modules = {
  ...enums.valuationTypes,
  CAT: 'cat',
  NONE: '-',
}

enums.appRouteName = {
  // TODO, when the legacy dvm tool will be removed, DVM and OVM should redirect to the same tool
  DVM: 'valuation.dvm',
  OVM: 'valuation.valuer-app',
  ERS: 'ers.request',
  OEPC: 'oepc.request',
}

enums.requestAction = {
  UNSUBMIT_VALUATION: 'unsubmit-valuation',
  SUBMIT_VALUATION: 'submit-valuation',
  SUBMIT: 'submit',
  UNSUBMIT: 'unsubmit',
  FLAG_FOR_REVIEW: 'flag-for-review',
  DEFER_TO_ONSITE: 'defer-to-onsite',
  CANCEL: 'cancel',
  RECOMPUTE_AVM: 'recompute-avm',
  ACCEPT_VALUATION: 'accept-valuation',
}

enums.contactFormSubjects = {
  REQ_FAILING: 'req-failing',
  CANT_DOWNLOAD_VAL_REPORT: 'cant-download-val-report',
  REQ_NOT_IN_DASHBOARD: 'req-not-in-dashboard',
  CANCEL_REQ: 'cancel-req',
  OTHER: 'other',
  REQ_NOT_EVAL_YET: 'req-not-eval-yet',
  REQ_BACK_TO_DRAFT: 'req-back-to-draft',
  REQ_CUSTOM_QUOTE: 'req-custom-quote',
  REQ_APPOINTMENT: 'req-appointment',
}

enums.pricingFlag = {
  OUT_OF_SCOPE: 'out_of_scope',
  CUSTOM_QUOTE: 'custom_quote',
}

enums.billingTypes = {
  INDIVIDUAL: 'individual',
  BUSINESS: 'business',
}

enums.paidBy = {
  BORROWER: 'borrower',
  ORGANIZATION: 'organization',
  OWNER: 'owner',
}

enums.documentPurpose = {
  EPC_CERTIFICATE: 'epc_certificate',
  EXPECTED_EPC: 'expected_epc',
  EXTERIOR_PICTURE: 'exterior_picture',
  INTERIOR_PICTURE: 'interior_picture',
  BUILDING_BLUEPRINT: 'building_blueprint',
  SPECIFICATIONS: 'specifications',
  CADASTRAL_PLAN: 'cadastral_plan',
  SALES_AGREEMENT: 'sales_agreement',
  AVM_REPORT: 'avm_report',
  DVM_REPORT: 'dvm_report',
  OVM_REPORT: 'ovm_report',
  ERS_REPORT: 'ers_report',
  RENOVATION_QUOTATION: 'renovation_quotation',
  COMMON_PARTS_EPC: 'common_parts_epc',
  EXTERIOR_PLAN: 'exterior_plan',
  PARCEL_PICTURE: 'parcel_picture',
  ANNEX_PICTURE: 'annex_picture',
  ANNEX_PLAN: 'annex_plan',
  FLOOD_REPORT: 'flood_report',
  OEPC_REPORT: 'oepc_report',
  RENTAL_CONTRACT: 'rental_contract',
  PROOF_OF_CONSTRUCTION: 'proof_of_construction',
  INVOICE: 'invoice',
  CREDIT_NOTE: 'credit_note',
  CALCULATION_SHEET: 'calculation_sheet',
}

/**
 * Purposes that accept only a single document (backend supersedes on re-upload).
 * Uploading multiple files simultaneously for these purposes returns 400.
 */
enums.singletonDocumentPurposes = [
  enums.documentPurpose.EPC_CERTIFICATE,
  enums.documentPurpose.EXPECTED_EPC,
]

enums.fileAccept = {
  DEFAULT: ['.jpg', '.jpeg', '.pdf', 'image/png', 'image/jpeg', 'application/pdf'],
  SPREADSHEET: ['.xls', '.xlsx'],
  PDF: ['.pdf', 'application/pdf'],
}

enums.documentPurposesCategories = {
  certificate: [
    enums.documentPurpose.EPC_CERTIFICATE,
    enums.documentPurpose.EXPECTED_EPC,
    enums.documentPurpose.COMMON_PARTS_EPC,
  ],

  picture: [
    enums.documentPurpose.EXTERIOR_PICTURE,
    enums.documentPurpose.INTERIOR_PICTURE,
    enums.documentPurpose.PARCEL_PICTURE,
    enums.documentPurpose.ANNEX_PICTURE,
  ],

  plan: [
    enums.documentPurpose.BUILDING_BLUEPRINT,
    enums.documentPurpose.CADASTRAL_PLAN,
    enums.documentPurpose.EXTERIOR_PLAN,
    enums.documentPurpose.ANNEX_PLAN,
  ],

  report: [
    enums.documentPurpose.AVM_REPORT,
    enums.documentPurpose.DVM_REPORT,
    enums.documentPurpose.OVM_REPORT,
    enums.documentPurpose.ERS_REPORT,
    enums.documentPurpose.OEPC_REPORT,
    enums.documentPurpose.FLOOD_REPORT,
  ],

  legal: [
    enums.documentPurpose.SALES_AGREEMENT,
    enums.documentPurpose.RENTAL_CONTRACT,
    enums.documentPurpose.PROOF_OF_CONSTRUCTION,
  ],

  technical: [enums.documentPurpose.SPECIFICATIONS, enums.documentPurpose.CALCULATION_SHEET],

  renovation: [enums.documentPurpose.RENOVATION_QUOTATION],
}

enums.paidBy = {
  BORROWER: 'borrower',
  ORGANIZATION: 'organization',
  OWNER: 'owner',
}

enums.paymentStatus = {
  NO_PAYMENT_NEEDED: 'no_payment_needed',
  PAYMENT_NEEDED: 'payment_needed',
  PAYMENT_PENDING: 'payment_pending',
  PAID: 'paid',
  SUCCEEDED: 'succeeded',
}

enums.property_destination = ['primary', 'secondary', 'buy_to_let']
enums.garage_property_destination = ['private', 'buy_to_let']

enums.defaultConfig = {
  fileMaxSize: 1024 ** 2 * 2,
}

enums.const = {
  attic_height: 2,
  floor_height: 2.8,
  attic_floor_factor: 0.8,
  attic_volume_factor: 0.5,
}

enums.iso_regions = {
  brussels: 'BE-BRU',
  flanders: 'BE-VLG',
  wallonia: 'BE-WAL',
}

enums.allRenovations = [
  {
    name: 'roofIn',
    type: 'roof',
  },
  {
    name: 'atticFloor',
    type: 'roof',
  },
  {
    name: 'wallExt',
    type: 'wall',
  },
  {
    name: 'windowsDouble',
    type: 'window',
  },
  {
    name: 'condGas',
    type: 'heating',
  },
  {
    name: 'heatPump',
    type: 'heating',
  },
  {
    name: 'wallCav',
    type: 'wall',
  },
  {
    name: 'unitPv',
    type: 'solar_panel',
  },
  {
    name: 'roofExt',
    type: 'roof',
  },
]

enums.ErsInputsValidation = {
  installation_year: {
    min: 1989,
  },
  f_construction_year: {
    min: 1700,
  },
  renovation_year: {
    min: 1700,
  },
  f_building_area: {
    min: 0,
    max: 1500,
  },
  f_roof_area: {
    min: 0,
    max: 1500,
  },
  exterior_wall_area: {
    min: 0,
    max: 3000,
  },
  f_living_area: {
    min: 18,
    max: 1500,
  },
  photovoltaic_surface: {
    min: 1.65,
    max: 60,
  },
  f_best_pane_area: {
    min: 2.0625,
    max: 75,
  },
}

enums.directions = {
  LEFT: 'left',
  RIGHT: 'right',
}

enums.bankPrePaymentAmounts = [0, 10, 20, 50, 100, 200]

enums.heatingTypes = [
  {
    fuel: 'gas',
    icon: 'ic-heating-fuel-gas',
    types: [
      {
        heating_type: 'boiler',
        subtype: 'standard',
        id: 'gas_boiler',
      },
      {
        heating_type: 'boiler',
        subtype: 'condensing',
        id: 'gas_condensing',
      },
      {
        heating_type: 'stove',
        subtype: null,
        id: 'gas_stove',
      },
    ],
  },
  {
    fuel: 'oil',
    icon: 'ic-heating-fuel-oil',
    types: [
      {
        heating_type: 'boiler',
        subtype: 'standard',
        id: 'oil_standard',
      },
      {
        heating_type: 'boiler',
        subtype: 'condensing',
        id: 'oil_condensing',
      },
      {
        heating_type: 'stove',
        subtype: null,
        id: 'oil_stove',
      },
    ],
  },
  {
    fuel: 'electricity',
    icon: 'ic-heating-fuel-electric',
    types: [
      {
        heating_type: 'heat_pump',
        subtype: null,
        id: 'electricity_heat_pump',
      },
      {
        heating_type: 'electric_heater',
        subtype: null,
        id: 'electricity_electric_heater',
      },
    ],
  },
  {
    fuel: 'wood',
    icon: 'ic-heating-fuel-wood',
    heating_type: 'stove',
    id: 'wood_stove',
  },
  {
    fuel: 'pellets',
    icon: 'ic-heating-fuel-pellets',
    heating_type: 'stove',
    id: 'pellets_stove',
  },
  {
    fuel: 'coal',
    icon: 'ic-heating-fuel-coal',
    heating_type: 'stove',
    id: 'coal_stove',
  },
  {
    fuel: null,
    icon: 'ic-heating-fuel-district-heating',
    heating_type: 'district_heating',
    id: 'district_heating',
  },
]

enums.renovationWarningRules = [
  // x: a selected renovation type
  // y: an array of renovation types that are available but not selected
  {
    x: 'window',
    y: ['roof', 'wall'],
  },
  {
    x: 'solar_panel',
    y: ['roof'],
  },
  {
    x: 'heating',
    y: ['roof', 'window', 'wall'],
  },
]

enums.epcMapping = {
  [enums.iso_regions.wallonia]: {
    'A++': [-Infinity, 0],
    'A+': [0, 45],
    'A': [45, 85],
    'B': [85, 170],
    'C': [170, 255],
    'D': [255, 340],
    'E': [340, 425],
    'F': [425, 510],
    'G': [510, Infinity],
  },
  [enums.iso_regions.flanders]: {
    'A+': [-Infinity, 0],
    'A': [0, 100],
    'B': [100, 200],
    'C': [200, 300],
    'D': [300, 400],
    'E': [400, 500],
    'F': [500, Infinity],
  },
  [enums.iso_regions.brussels]: {
    A: [-Infinity, 45],
    B: [45, 95],
    C: [95, 150],
    D: [150, 210],
    E: [210, 275],
    F: [275, 345],
    G: [345, Infinity],
  },
}

enums.epcColors = {
  [enums.iso_regions.wallonia]: {
    'A++': 'epc-green',
    'A+': 'epc-green',
    'A': 'epc-green',
    'B': 'epc-light-green',
    'C': 'epc-lime',
    'D': 'epc-yellow',
    'E': 'epc-amber',
    'F': 'epc-orange',
    'G': 'epc-red',
  },
  [enums.iso_regions.flanders]: {
    'A+': 'epc-green',
    'A': 'epc-light-green',
    'B': 'epc-lime',
    'C': 'epc-yellow',
    'D': 'epc-amber',
    'E': 'epc-orange',
    'F': 'epc-red',
  },
  [enums.iso_regions.brussels]: {
    A: 'epc-green',
    B: 'epc-light-green',
    C: 'epc-lime',
    D: 'epc-yellow',
    E: 'epc-amber',
    F: 'epc-orange',
    G: 'epc-red',
  },
}

enums.consumptions = {
  canonical_unit: {
    [enums.iso_regions.brussels]: {
      electricity: {
        min: 1000,
        med: 2600,
        max: 6600,
      },
      electricity_heat: {
        min: 3153,
        med: 7884,
        max: 17560,
      },
      gas: {
        min: 595,
        med: 1459,
        max: 3027,
      },
      oil: {
        min: 457,
        med: 1121,
        max: 2325,
      },
      wood: {
        min: 1420,
        med: 2557,
        max: 4048,
      },
      pellets: {
        min: 1380,
        med: 2483,
        max: 3932,
      },
      coal: {
        min: 768,
        med: 1382,
        max: 2188,
      },
      district_heating: {
        min: 5500,
        med: 13500,
        max: 28000,
      },
    },
    [enums.iso_regions.flanders]: {
      electricity: {
        min: 1600,
        med: 3600,
        max: 7600,
      },
      electricity_heat: {
        min: 10295,
        med: 19251,
        max: 32281,
      },
      gas: {
        min: 1081,
        med: 1946,
        max: 3081,
      },
      oil: {
        min: 1205,
        med: 2169,
        max: 3434,
      },
      wood: {
        min: 1420,
        med: 2557,
        max: 4048,
      },
      pellets: {
        min: 1380,
        med: 2483,
        max: 3932,
      },
      coal: {
        min: 768,
        med: 1382,
        max: 2188,
      },
      district_heating: {
        min: 10000,
        med: 18000,
        max: 28500,
      },
    },
    [enums.iso_regions.wallonia]: {
      electricity: {
        min: 1600,
        med: 3800,
        max: 9200,
      },
      electricity_heat: {
        min: 7629,
        med: 15223,
        max: 27604,
      },
      gas: {
        min: 1027,
        med: 1946,
        max: 2900,
      },
      oil: {
        min: 1067,
        med: 2022,
        max: 3258,
      },
      wood: {
        min: 1304,
        med: 2471,
        max: 3981,
      },
      pellets: {
        min: 1267,
        med: 2400,
        max: 3866,
      },
      coal: {
        min: 705,
        med: 1336,
        max: 2152,
      },
      district_heating: {
        min: 9500,
        med: 18000,
        max: 29000,
      },
    },
  },
  kwh: {
    [enums.iso_regions.brussels]: {
      electricity: {
        min: 1000,
        med: 2600,
        max: 6600,
      },
      electricity_heat: {
        min: 3153,
        med: 7884,
        max: 17560,
      },
      gas: {
        min: 5500,
        med: 13500,
        max: 28000,
      },
      oil: {
        min: 4603,
        med: 11297,
        max: 23432,
      },
      wood: {
        min: 6250,
        med: 11250,
        max: 17812,
      },
      pellets: {
        min: 6250,
        med: 11250,
        max: 17812,
      },
      coal: {
        min: 6250,
        med: 11250,
        max: 17812,
      },
      district_heating: {
        min: 5500,
        med: 13500,
        max: 28000,
      },
    },
    [enums.iso_regions.flanders]: {
      electricity: {
        min: 1600,
        med: 3600,
        max: 7600,
      },
      electricity_heat: {
        min: 10295,
        med: 19251,
        max: 32281,
      },
      gas: {
        min: 10000,
        med: 18000,
        max: 28500,
      },
      oil: {
        min: 12146,
        med: 21862,
        max: 34615,
      },
      wood: {
        min: 6250,
        med: 11250,
        max: 17812,
      },
      pellets: {
        min: 6250,
        med: 11250,
        max: 17812,
      },
      coal: {
        min: 6250,
        med: 11250,
        max: 17812,
      },
      district_heating: {
        min: 10000,
        med: 18000,
        max: 28500,
      },
    },
    [enums.iso_regions.wallonia]: {
      electricity: {
        min: 1600,
        med: 3800,
        max: 9200,
      },
      electricity_heat: {
        min: 7629,
        med: 15223,
        max: 27604,
      },
      gas: {
        min: 9500,
        med: 18000,
        max: 29000,
      },
      oil: {
        min: 10757,
        med: 20383,
        max: 32839,
      },
      wood: {
        min: 5738,
        med: 10871,
        max: 17515,
      },
      pellets: {
        min: 5738,
        med: 10871,
        max: 17515,
      },
      coal: {
        min: 5738,
        med: 10871,
        max: 17515,
      },
      district_heating: {
        min: 9500,
        med: 18000,
        max: 29000,
      },
    },
  },
}

enums.documentSource = {
  VALUER: 'valuer',
  DISPATCHER: 'dispatcher',
  BORROWER: 'borrower',
  OWNER: 'owner',
  GOOGLE_STREETVIEW: 'google_streetview',
  ROCKESTATE: 'rockestate',
}

enums.buildingTypes = {
  HOUSE: 'house',
  NEW_HOUSE: 'new_house',
  APARTMENT: 'apartment',
  NEW_APARTMENT: 'new_apartment',
  CONSTRUCTION_PLOT: 'construction_plot',
  OTHER_PLOT: 'other_plot',
  GARAGE: 'garage',
  APARTMENT_BLOCK: 'apartment_block',
  COMMERCIAL: 'commercial',
  INVESTMENT: 'investment', // Deprecated, use APARTMENT_BLOCK
  OTHER: 'other',
}

enums.roomTypes = {
  ENTRANCE_HALL: 'entrance_hall',
  LIVING_ROOM: 'living_room',
  KITCHEN: 'kitchen',
  BEDROOM: 'bedroom',
  WASH_ROOM: 'wash_room',
  BASEMENT: 'basement',
  GARAGE: 'garage',
  ATTIC: 'attic',
  DINING_ROOM: 'dining_room',
  TOILET: 'toilet',
  HALL_CORRIDOR: 'hall_corridor',
  NIGHT_HALL: 'night_hall',
  DRESSING_ROOM: 'dressing_room',
  TECHNICAL_LOCAL: 'technical_local',
  OFFICE: 'office',
  STORAGE: 'storage',
  BALCONY_TERRACE: 'balcony_terrace',
  VERANDA: 'veranda',
  OTHER: 'other',
}

enums.epcSource = {
  CERTIFICATE: 'certificate',
  USER_ESTIMATE: 'user_estimate',
}

enums.requestPurpose = {
  NEW_LOAN: 'new_loan',
  REFINANCING: 'refinancing',
}

enums.buildingTypesList = Object.values(enums.buildingTypes)

enums.ocrStatus = {
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILED: 'failed',
}

enums.ersEstimationType = {
  HCE: 'hce',
  EPC_BASED: 'epc_based',
}

enums.appointmentStatus = {
  INCOMPLETE: 'incomplete',
  PENDING_CONFIRMATION: 'pending_confirmation',
  CANCELLED: 'cancelled',
  CANCELLED_BY_VALUER: 'cancelled_by_valuer',
  CONFIRMED: 'confirmed',
  COMPLETED: 'completed',
}

enums.feedbackType = {
  POSITIVE: 'positive',
  WARNING: 'warning',
  NEGATIVE: 'negative',
  INFO: 'info',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
}

enums.specialHandlingBuildingTypes = new Set([
  enums.buildingTypes.GARAGE,
  enums.buildingTypes.APARTMENT_BLOCK,
  enums.buildingTypes.COMMERCIAL,
  enums.buildingTypes.OTHER,
])

enums.constructionVatOptions = [
  {
    label: '6%',
    value: 0.06,
  },
  {
    label: '21%',
    value: 0.21,
  },
]

enums.validationPurpose = [
  'epc_certificate',
  'ers_report',
  'exterior_picture',
  'interior_picture',
  'sales_agreement',
  'deed_of_sale',
  'listing',
  'buyer_data',
  'renovation_quotation',
  'renovation_specifications',
  'specifications',
  'building_blueprint',
  'cadastral_plan',
  'expected_epc',
  'email',
  'external_report',
  'avm_report',
  'dvm_report',
  'proof_of_construction',
  'calculation_sheet',
  'other',
]

enums.actions = {
  EDIT: 'edit',
  CANCEL: 'cancel',
  SUBMIT: 'submit',
  UNSUBMIT_REQUEST: 'unsubmit_request',
  DOWNLOAD_REPORT: 'download_report',
  GENERATE_REPORT: 'generate_report',
  SUBMIT_VALUATION: 'submit_valuation',
  UNSUBMIT_VALUATION: 'unsubmit_valuation',
  CONVERT_TO: 'convert_to',
}

enums.badgesStatus = {
  CUSTOM_QUOTE_REQUIRED: 'custom_quote_required',
  REFUND_NEEDED: 'refund_needed',
  REPORT_GENERATION_NEEDED: 'report_generation_needed',
  RESUBMITTED: 'resubmitted',
  HAS_RENOVATION: 'has_renovation',
  NEEDS_BORROWER_EMAIL: 'needs_borrower_email',
  NEEDS_BORROWER_ACTION: 'needs_borrower_action',
  APPOINTMENT_PENDING_CONFIRMATION: 'appointment_pending_confirmation',
  APPOINTMENT_CONFIRMED: 'appointment_confirmed',
  APPOINTMENT_CANCELLED: 'appointment_cancelled',
  APPOINTMENT_CANCELLED_BY_VALUER: 'appointment_cancelled_by_valuer',
  REPORT_NEEDS_OWNER_APPROVAL: 'report_needs_owner_approval',
}

enums.borrowerFlowSteps = {
  OVM_COMPLETE: 'ovm-complete',
  OVM_PAYMENT: 'ovm-payment',
  OVM_REPORT: 'ovm-report',

  DVM_WAITING: 'dvm-waiting',
  DVM_PAYMENT: 'dvm-payment',
  DVM_REPORT: 'dvm-report',
  COMPLETE: 'complete',
}

enums.propertyGoals = {
  BUY: 'buy',
  SELL: 'sell',
  RENOVATE: 'renovate',
  // RENT: 'rent',
  // OTHER: 'other',
}

enums.projectSteps = {
  DISCOVERY: 'discovery',
  BEFORE_VISIT: 'before_visit',
  DURING_VISIT: 'during_visit',
  AFTER_VISIT_ASSESSMENT: 'after_visit_assessment',
  OFFER_DECISION: 'offer_decision',
  FINANCING_CONTRACTS: 'financing_contracts',
  WORKS_PLANNING: 'works_planning',
  DURING_WORKS: 'during_works',
  AFTER_WORKS: 'after_works',
  ADMINISTRATIVE_OTHER: 'administrative_other',
}
enums.projectStepsWithIcon = {
  DISCOVERY: {
    value: enums.projectSteps.DISCOVERY,
    icon: 'mdi-home-search',
  },
  BEFORE_VISIT: {
    value: enums.projectSteps.BEFORE_VISIT,
    icon: 'mdi-home-clock-outline',
  },
  DURING_VISIT: {
    value: enums.projectSteps.DURING_VISIT,
    icon: 'mdi-calendar-badge',
  },
  AFTER_VISIT_ASSESSMENT: {
    value: enums.projectSteps.AFTER_VISIT_ASSESSMENT,
    icon: 'mdi-calendar-check',
  },
  OFFER_DECISION: {
    value: enums.projectSteps.OFFER_DECISION,
    icon: 'mdi-file-document-edit',
  },
  FINANCING_CONTRACTS: {
    value: enums.projectSteps.FINANCING_CONTRACTS,
    icon: 'mdi-bank-check',
  },
  WORKS_PLANNING: {
    value: enums.projectSteps.WORKS_PLANNING,
    icon: 'mdi-hammer-wrench',
  },
  DURING_WORKS: {
    value: enums.projectSteps.DURING_WORKS,
    icon: 'mdi-account-hard-hat',
  },
  AFTER_WORKS: {
    value: enums.projectSteps.AFTER_WORKS,
    icon: 'mdi-calendar-check',
  },
  ADMINISTRATIVE_OTHER: {
    value: enums.projectSteps.ADMINISTRATIVE_OTHER,
    icon: 'mdi-briefcase-account',
  },
}

enums.projectCTA = {
  REQUEST_ASSESSMENT_OVM: 'request_assessment_ovm',
  REQUEST_ASSESSMENT_ERS: 'request_assessment_ers',
  REQUEST_ASSESSMENT_OEPC: 'request_assessment_oepc',
}

enums.borrowerFlowCompletedSteps = {
  ovm: [
    enums.borrowerFlowSteps.OVM_COMPLETE,
    enums.borrowerFlowSteps.OVM_PAYMENT,
    enums.borrowerFlowSteps.OVM_REPORT,
  ],
  dvm: [
    enums.borrowerFlowSteps.DVM_WAITING,
    enums.borrowerFlowSteps.DVM_PAYMENT,
    enums.borrowerFlowSteps.DVM_REPORT,
  ],
}

enums.languages = {
  EN: 'en-BE',
  FR: 'fr-BE',
  NL: 'nl-BE',
  DE: 'de-BE',
}

enums.billingTypes = {
  INDIVIDUAL: 'individual',
  BUSINESS: 'business',
}

enums.timeFilters = {
  LAST_WEEK: 'last_week',
  LAST_MONTH: 'last_month',
  LAST_YEAR: 'last_year',
}

enums.representativeRoles = {
  NOTARY: 'notary',
  BROKER: 'broker',
  RENTER: 'renter',
  REAL_ESTATE_AGENT: 'real_estate_agent',
  OTHER: 'other',
}

export default enums
